import Vue from 'vue';
import App from './App.vue';
import Vant from 'vant';
import 'vant/lib/index.css';
import router from './router';
import http from './http';
import VueAwesomeSwiper from 'vue-awesome-swiper'
import common from './common/function'
import 'swiper/swiper-bundle.css'
import store from './store'
import VueI18n from 'vue-i18n';

import 'video.js/dist/video-js.css'
import './assets/css/mobile-shell.css'

Vue.prototype.$http = http
Vue.prototype.common = common
Vue.config.productionTip = false
Vue.use(VueAwesomeSwiper, /* { default options with global component } */)
Vue.use(Vant);
Vue.use(VueI18n);

// 仅保留英语
localStorage.setItem("lang", "en_us");
const i18n = new VueI18n({
  globalInjection: true,
  locale: "en_us",
  fallbackLocale: "en_us",
  silentTranslationWarn: true,
  messages: {
    'en_us': require('./assets/languages/en_us.json'),
  }
});
new Vue({
  store,
  router,
  i18n,
  render: h => h(App),
}).$mount('#app')
